'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var Checkbox_FilledCheckbox_index = require('./FilledCheckbox/index.js');
var styled = require('styled-components');
var browser_utils = require('../browser.utils-bfcc05c6.js');
require('../viewport.utils-0c2b4e2b.js');
require('../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledCheckmarkCheckbox = styled__default['default'](Checkbox_FilledCheckbox_index['default']).withConfig({ displayName: "ww-uikit_StyledCheckmarkCheckbox_loy4z5m7", componentId: "sc-qnlcvr" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    & input[type='checkbox'] {\n        &:checked {\n            appearance: none;\n            background: white;\n        }\n\n        &:after {\n            display: none;\n            content: '';\n            position: absolute;\n            left: 6px;\n            top: -5px;\n            width: 8px;\n            height: 16px;\n            border: solid ", ";\n            border-width: 0 2px 2px 0;\n            transform: rotate(45deg);\n        }\n\n        &:checked:after {\n            display: block;\n        }\n\n        &:checked:disabled:after {\n            border-color: ", ";\n        }\n    }\n\n    ", "\n"], ["\n    & input[type='checkbox'] {\n        &:checked {\n            appearance: none;\n            background: white;\n        }\n\n        &:after {\n            display: none;\n            content: '';\n            position: absolute;\n            left: 6px;\n            top: -5px;\n            width: 8px;\n            height: 16px;\n            border: solid ", ";\n            border-width: 0 2px 2px 0;\n            transform: rotate(45deg);\n        }\n\n        &:checked:after {\n            display: block;\n        }\n\n        &:checked:disabled:after {\n            border-color: ", ";\n        }\n    }\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal60;
}, browser_utils.forIE(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n        align-items: center;\n        > label {\n            vertical-align: middle;\n        }\n    "], ["\n        align-items: center;\n        > label {\n            vertical-align: middle;\n        }\n    "]))));
var templateObject_1, templateObject_2;

var Checkbox = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'filled' : _b, props = tslib_es6.__rest(_a, ["variant"]);
    if (variant === 'checkmark') {
        return React__default['default'].createElement(StyledCheckmarkCheckbox, tslib_es6.__assign({}, props));
    }
    return React__default['default'].createElement(Checkbox_FilledCheckbox_index['default'], tslib_es6.__assign({}, props));
};

function useCheckbox(_a) {
    var _b = _a.isChecked, isChecked = _b === void 0 ? false : _b, value = _a.valueOnChecked, _c = _a.onChangeCallback, onChangeCallback = _c === void 0 ? function () { return undefined; } : _c;
    var _d = React.useState(isChecked), checked = _d[0], setChecked = _d[1];
    React.useEffect(function () {
        setChecked(isChecked);
    }, [isChecked]);
    var onChange = function (event) {
        var currentChecked = event.target.checked;
        setChecked(currentChecked);
        onChangeCallback(currentChecked, value);
    };
    return { checked: checked, value: value, onChange: onChange };
}

exports.default = Checkbox;
exports.useCheckbox = useCheckbox;
//# sourceMappingURL=index.js.map
